
import Vue from "vue";
import { VFadeTransition } from "vuetify/lib";
import {
  getHazratMassomehData,
  getImamHussainData,
} from "@/core/functions/localstorage-data";
import { HolyShrineType } from "@/enums/holy-shrine-type";

export default Vue.extend({
  name: "home",
  components: {
    VFadeTransition,
  },
  data() {
    return {
      isOpen: false,
      data: [
        {
          name: "حرم مطهر امام رضا (علیه السلام)",
          image: require("@/assets/img/emamReza.png"),
        },
        {
          name: "حرم مطهر امام حسین (علیه السلام)",
          image: require("@/assets/img/emamHossein.png"),
          features: null,
        },
        {
          name: "حرم مطهر حضرت معصومه (سلام الله علیها)",
          image: require("@/assets/img/hazratMasoome.png"),
        },
      ],
    };
  },

  methods: {
    handelGoFeautres(item) {
      switch (item.name) {
        case "حرم مطهر حضرت معصومه (سلام الله علیها)":
          this.$router.push({
            name: "hazrat-masoomeh-ziarat-register",
            query: {
              utm_source: "badesaba",
              utm_medium: "carte-ziyarat-niyabati",
              utm_campaign: "ziyarate-hazrate-masume",
            },
          });
          break;

        case "حرم مطهر امام رضا (علیه السلام)":
          this.$router.push({
            name: "imam-reza-features",
          });
          break;

        case "حرم مطهر امام حسین (علیه السلام)":
          this.$router.push({
            name: "imam-hussain-ziarat-register",
          });
          break;

        default:
          break;
      }
    },
    handleInquery(type) {
      
      if (type == 1) {
        if (getImamHussainData().length) {
          this.$router.push({
            name: "inquiry",
            params: { type: HolyShrineType.ImamHussain },
          });
        } else {
          this.$store.commit("setconfigInquiryRegister", {
            isOpen: true,
            imamHussainZiarat: true,
            hazratMassomehZiarat: false,
          });
        }
      } else {
        
        if (getHazratMassomehData().length) {
          this.$router.push({
            name: "inquiry",
            params: { type: HolyShrineType.HazratMassomeh },
          });
        }
        else{
          this.$store.commit("setconfigInquiryRegister", {
            isOpen: true,
            imamHussainZiarat: false,
            hazratMassomehZiarat: true,
          });
        }
        
      }
    },
  },
});
